import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { RegexConstants } from '../../constants/regex.constants';

export interface DialogData {
  email: string;
}

@Component({
  selector: 'fc-dialog-ineligible-parcel',
  templateUrl: './dialog-ineligible-parcel.component.html',
  styleUrls: ['./dialog-ineligible-parcel.component.scss'],
})
export class DialogIneligibleParcelComponent implements OnInit {
  ineligibleParcelForm: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogIneligibleParcelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.ineligibleParcelForm = this.formBuilder.group({
      email: [null, [Validators.maxLength(254), Validators.pattern(RegexConstants.EMAIL), Validators.required]],
    });
    this.ineligibleParcelForm.get('email').setValue(this.data.email);
  }

  onNoClick(): void {
    this.dialogRef.close({ email: null });
  }

  get email(): AbstractControl {
    return this.ineligibleParcelForm.get('email');
  }
}
